const targetAuthorsList = document.querySelector('.authors__list');

if (targetAuthorsList) {
    const buttonAuthorsList = targetAuthorsList.querySelector('.button-show-authors');
    buttonAuthorsList.addEventListener('click', e => {
        targetAuthorsList.querySelector('.authors__list__block').classList.add('active');
        targetAuthorsList.querySelector('.authors__list__button').classList.add('hidden');
    });
}

const authorsButton = document.querySelector('.authors__list__tag__button');

if (authorsButton) {
    authorsButton.addEventListener('click', () => {
        document.querySelector('.authors__list__tag').classList.toggle('active');
    });
}
